import React from 'react'
import ReactDOM from 'react-dom'
import intl from 'react-intl-universal'

import template from './template.html'
import { FeaturedMediaModal } from '~/reactapp/Settings/FeaturedMedia/Modal/featuredMediaModal'

export default [directive]

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      companySettings: '<',
      sites: '<',
      applyChanges: '&',
    },
    controller: ['$ngRedux', Controller],
    link: Link,
  }
}

function Controller($ngRedux) {
  this.intl = intl

  const hideModal = () => {
    this.renderComponent(false)
  }

  this.renderComponent = (modalOpen) => {
    this.render &&
      this.render({
        store: $ngRedux,
        modalOpen,
        hideModal,
      })
  }
}

function reactRenderFactory(angularScope, rootElement, FeaturedMediaModal) {
  angularScope.$on('$destroy', () =>
    ReactDOM.unmountComponentAtNode(rootElement)
  )
  return (props) => {
    ReactDOM.render(
      props.modalOpen && <FeaturedMediaModal {...props} />,
      rootElement
    )
  }
}

function Link(scope, el) {
  const rootElement = el.find('#featuredMediaSettings_react')[0]
  scope.vm.render = reactRenderFactory(scope, rootElement, FeaturedMediaModal)
}
